import {NgModule} from '@angular/core';
import {IncidentOccurrencePipe} from './incident-occurrence.pipe';

@NgModule({
  declarations: [IncidentOccurrencePipe],
  exports: [IncidentOccurrencePipe],
})
export class IncidentOccurrenceModule {}
